(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ew-contact-menu"] && !Shopify.designMode) return;
  try {
    const contactMenu = document.getElementById('ew-contact');
contactMenu?.querySelector('.ew-contact__close')?.addEventListener('click', () => {
  contactMenu.open = false;
  contactMenu.querySelector('summary').focus();
});
document.addEventListener('click', (event) => {
  if (contactMenu && !contactMenu.contains(event.target)) contactMenu.open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && contactMenu?.open) {
    contactMenu.open = false;
    contactMenu.querySelector('summary').focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
